import { Transition } from "Components/Common/Dialog/DialogComponents";

export const MuiTypography = {
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      lineHeight: 1.5,
      color: theme.palette?.[ownerState?.color || "secondary"]?.main,
    }),
  },
  variants: [
    {
      props: { variant: "h1" },
      style: ({ theme, ownerState }) => ({
        fontSize: "50px",
        color: theme.palette?.[ownerState?.color || "secondary"]?.main,
      }),
    },
    {
      props: { variant: "h2" },
      style: ({ theme, ownerState }) => ({
        fontSize: "32px ",
        color: theme.palette?.[ownerState?.color || "secondary"]?.main,
      }),
    },
    {
      props: { variant: "h3" },
      style: ({ theme, ownerState }) => ({
        fontSize: "24px ",
        color: theme.palette?.[ownerState?.color || "secondary"]?.main,
      }),
    },
    {
      props: { variant: "h4" },
      style: ({ theme, ownerState }) => ({
        fontSize: "16px !important",
        color: theme.palette?.[ownerState?.color || "secondary"]?.main,
      }),
    },
    {
      props: { variant: "h5" },
      style: ({ theme, ownerState }) => ({
        fontSize: "14px !important",
        color: theme.palette?.[ownerState?.color || "secondary"]?.main,
      }),
    },
    {
      props: { variant: "h6" },
      style: ({ theme, ownerState }) => ({
        fontSize: "12px !important",
        color: theme.palette?.[ownerState?.color || "secondary"]?.main,
      }),
    },
    {
      props: { upperCase: true },
      style: {
        textTransform: "uppercase",
      },
    },
    {
      props: { bold: true },
      style: {
        fontWeight: "700",
      },
    },
    {
      props: { semiBold: true },
      style: {
        fontWeight: "600",
      },
    },
    {
      props: { medium: true },
      style: {
        fontWeight: "500",
      },
    },
    {
      props: { regular: true },
      style: {
        fontWeight: "400",
      },
    },
  ],
};

export const MuiButton = {
  defaultProps: {
    disableElevation: true,
    disableFocusRipple: true,
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      textTransform: "none ",
      "&:disabled": {},
    }),
  },
  variants: [
    {
      props: { variant: "contained" },
      style: ({ theme, ownerState }) => ({
        borderRadius: "4px",
        padding: "8px 20px !important",
        height: "40px",
        color: theme.palette.white.main,
        fontSize: "14px",
        " &:disabled": {
          height: "38px ",
          color: theme.palette.white.main,
          // color: `${theme.palette.secondary.main}90 !important`,
          "&>span": {
            "&>svg": {
              fill: `${theme.palette.secondary.main}90 !important`,
            },
          },
        },
      }),
    },
    {
      props: { variant: "outlined" },
      style: ({ theme, ownerState }) => ({
        borderRadius: "5px",
        padding: "8px 20px !important",
        height: "40px",
        color: theme.palette.primary.main,
        fontSize: "14px",
        background: `${theme.palette.primary.main}10`,
        "&:hover": {
          background: `${theme.palette.primary.main}20`,
        },
        " &:disabled": {
          height: "38px ",
          // background: `${theme.palette.secondary.main}10 !important`,
          "&>span": {
            "&>svg": {
              fill: `${theme.palette.secondary.main}80 !important`,
            },
          },
        },
      }),
    },
    {
      props: { medium: true },
      style: {
        height: "30px",
        padding: "5px 18x !important",
      },
    },
    {
      props: { upperCase: true },
      style: {
        textTransform: "uppercase",
      },
    },
  ],
};

export const MuiTextField = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      marginTop: "8px",
      fontFamily: "Poppins !important",
      fontWeight: "400!important",
      // letterSpacing: "1px",

      "&>label": {
        fontSize: "10px !important",
        color: "#747474 !important",
      },
      "&>div": {
        borderRadius: "5px",
        background: theme.palette.white.main,
        color: "#747474 !important",
        // color: theme.palette.secondary.main,
        "&>input": {
          fontSize: "14px !important",
          "&:hover": {
            borderColor: "#979797",
            // borderColor: "#DADADA",
          },
        },
        "&>fieldset": {
          borderColor: "#979797",
          // borderColor: "#DADADA",
        },
      },
      "& .Mui-focused": {
        "&>fieldset": {
          borderWidth: "1px !important",
        },
      },
      "& .MuiInputLabel-root": {
        transform: "translate(14px, 11px) scale(1.5) !important",
      },
      "& .MuiInputLabel-shrink": {
        transform: "translate(12px, -9px) scale(1.5) !important",
        "&.MuiInputLabel-sizeSmall": {
          transform: "translate(12px, -9px) scale(1.5) !important",
          fontSize: "8px !important",
        },
        "&.MuiInputLabel-sizeMedium": {
          transform: "translate(12px, -9px) scale(1.5) !important",
          fontSize: "8px !important",
        },
      },
    }),
  },
  variants: [
    {
      props: { secondary: true },
      style: ({ theme, ownerState }) => ({
        height: ownerState?.medium ? "40px" : "50px",
        "&>div": {
          height: ownerState?.medium ? "40px" : "50px",
          borderRadius: "4px",
          background: theme.palette.white.main,
          boxShadow: "0px 0px 10px rgba(90, 104, 114, 0.1)",
          "&>input": {
            height: "48px !important",
            padding: ownerState?.withPadding ? "0px 14px" : "0px",
            color: "#747474 !important",
            // color: theme.palette.secondary.main,
            fontSize: "12px !important",
          },
          "&>fieldset": {
            border: "none",
          },
        },
      }),
    },
  ],
};

export const MuiFormControl = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      "&>div": {
        height: "40px",
        width: "100% !important",
        borderRadius: "5px",
        background: theme.palette.white.main,
        color: theme.palette.secondary.main,
        "&>input": {
          padding: "0px 14px",
          fontSize: "14px",
        },
        "&>fieldset": {
          borderColor: theme.palette.secondary.main,
        },
      },
      "& .Mui-focused": {
        "&>fieldset": {
          borderWidth: "1px !important",
        },
      },
      "& .MuiFormLabel-root": {
        transform: "translate(14px, 8px) scale(1)",
      },
    }),
  },
  variants: [
    {
      props: { secondary: true },
      style: ({ theme, ownerState }) => ({
        height: ownerState?.medium ? "40px" : "50px",
        "&>div": {
          height: ownerState?.medium ? "40px" : "50px",
          borderRadius: "4px",
          background: theme.palette.white.main,
          boxShadow: "0px 0px 10px rgba(90, 104, 114, 0.1)",
          "&>input": {
            height: "50px !important",
            padding: ownerState?.withPadding ? "0px 14px" : "0px",
            color: "#747474 ",
            // color: theme.palette.secondary.main,
            fontSize: "14px",
          },
          "&>fieldset": {
            border: "none",
          },
        },
      }),
    },
  ],
};

export const MuiAutocomplete = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      "&>label": {
        fontSize: "10px !important",
      },
      "&>div": {
        height: "40px",
        borderRadius: "5px",
        background: theme.palette.white.main,
        color: theme.palette.secondary.main,
        "&>input": {
          fontSize: "14px",
        },
      },
      "& .MuiOutlinedInput-root": {
        padding: "4px !important",
        paddingRight: "50px !important",
        "&>input": {
          minWidth: "0px !important",
        },
      },
      "& .MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input":
        {
          minWidth: "0px !important",
        },
      "& .Mui-focused": {
        "&>fieldset": {
          borderWidth: "1px !important",
        },
      },
      "& .MuiInputLabel-shrink": {
        transform: "translate(12px, -9px) scale(0.90)",
      },
    }),
  },
  variants: [
    {
      props: { secondary: true },
      style: ({ theme, ownerState }) => ({
        height: ownerState?.medium ? "40px" : "50px",
        "&>div": {
          height: ownerState?.medium ? "40px" : "50px",
          borderRadius: "4px",
          background: theme.palette.white.main,
          boxShadow: "0px 0px 10px rgba(90, 104, 114, 0.1)",
          "&>input": {
            height: "50px !important",
            padding: ownerState?.withPadding ? "0px 14px" : "0px",
            // color: theme.palette.secondary.main,
            color: "#747474",
            fontSize: "14px",
          },
          "&>fieldset": {
            border: "none",
          },
        },
      }),
    },
  ],
};

export const MuiAvatar = {
  MuiAvatar: {
    variants: [
      {
        props: { variant: "rounded" },
        style: {
          borderRadius: "50%",
          img: {
            borderRadius: "50%",
          },
        },
      },
      {
        props: { isActive: true },
        style: ({ ownerState, theme }) => ({
          "&:after": {
            position: "absolute",
            content: !ownerState?.noBorder && "''",
            width: ownerState?.dotLength || "12px",
            height: ownerState?.dotLength || "12px",
            right: ownerState?.variant == "rounded" ? "3px" : "-3px",
            bottom: ownerState?.variant == "rounded" ? "3px" : "-3px",
            borderRadius: "50%",
            zIndex: 2,
            border: `2px solid ${theme.palette.background.paper}`,
            backgroundColor: `${theme.palette.green.main}`,
          },
        }),
      },
    ],
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        borderRadius: "5px",
        width: "40px",
        height: "40px",
        padding: !ownerState?.noBorder ? "2px" : "0px",
        overflow: "inherit",
        "&:before": {
          position: "absolute",
          content: !ownerState?.noBorder && "''",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          borderRadius: ownerState?.variant == "rounded" ? "50px" : "5px",
          backgroundColor: `${theme.palette.background.paper}`,
        },
        "&>span": {
          position: "relative",
          color: theme.palette.primary.main,
          fontWeight: "bold",
          fontSize: "20px",
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          background: theme.palette.background.default,
          borderRadius: ownerState?.variant == "rounded" ? "50%" : "2px",
        },
      }),
      img: {
        borderRadius: "5px",
        position: "relative",
      },
    },
  },
};

export const MuiLink = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      cursor: "pointer",
    }),
  },
};

export const MuiChip = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      borderRadius: "4px",
      height: "27px",
      color: "#747474 ",
      fontFamily: "Poppins !important",
      fontWeight: "400!important",
      fontSize: "14px !important",
    }),
  },
};

export const MuiDivider = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      background: theme.palette?.[ownerState?.color || "secondary"]?.main,
    }),
  },
};

export const MuiTable = {
  MuiTableContainer: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        height: ownerState?.maxHeight || "calc(100vh - 174px)",
        width: "100%",
        // borderRadius: "10px",
        // padding: "15px 10px",
        boxShadow: "0px 0px 10px rgba(26, 102, 122, 0.1)",
        background: theme.palette.background.paper,
      }),
    },
  },

  MuiTableHead: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        boxShadow: "none",
        "&>tr": {
          "&>th": {
            background: "#fff",
            // whiteSpace: "nowrap",
            // backgroundColor: theme.palette.background.grey,
            // padding: "16px 20px",
            fontSize: "16px",
            // borderBottom: "0px",
            textAlign: "left",
            "&:first-child": {
              // borderRadius: "8px 0px 0px 8px",
              // maxwidth: "80px !important",
            },
            "&:last-child": {
              // borderRadius: "0px 8px 8px 0px",
              // width: "40px",
            },
            fontWeight: "700",
            // color: theme.palette.secondary.main,
          },
        },
      }),
    },
  },

  MuiTableBody: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        boxShadow: "none",
        "&>tr": {
          "&>td": {
            // whiteSpace: "nowrap",
            padding: "2px 20px",
            borderBottom: `1px solid ${theme.palette.background.grey}`,
            textAlign: "left",
            color: theme.palette.secondary.main,
          },
        },
      }),
    },
  },

  MuiTableCell: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        fontWeight: ownerState?.semiBold ? "600" : "",
        borderBottom: ownerState?.noBorder && "0px !important",
      }),
    },
  },
};

export const MuiDialog = {
  MuiDialog: {
    defaultProps: {
      TransitionComponent: Transition,
    },
    styleOverrides: {
      paper: ({ ownerState, theme }) => ({
        position: "absolute",
        top: "100px",
        width: "100%",
        padding: "0px 20px",
        zIndex: "1600",
      }),
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        padding: "18px 0px 10px 0px",
        borderBottom: `1px solid ${theme.palette.background.grey}`,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "&>p": {
          fontSize: "24px",
          fontWeight: "500",
        },
      }),
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        padding: "20px 0px",
      }),
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        padding: "0px 0px 0px 0px",
        justifyContent: "center",
        borderTop: `1px solid ${theme.palette.background.grey}`,
        "& :not(:first-of-type)": {
          marginLeft: "20px",
        },
      }),
    },
  },
};
